export const encryptionKey = '983674$#@$^@1ERF';
export const maxAttendees = 20;
